/**
 * Desktop Sticky ATC Bar
 * Shows quantity + price + ATC button + wishlist at bottom of right panel
 * when the main product form ATC button scrolls out of view.
 * Desktop only (831px+).
 */
(function () {
  // Must match the CSS media query in snippets/desktop-sticky-atc.liquid
  // (.desktop-sticky-atc is display:none below this width).
  var DESKTOP_BREAKPOINT = 831;

  function init() {
    var stickyBar = document.getElementById('desktop-sticky-atc');
    if (!stickyBar || stickyBar.dataset.initialized) return;
    stickyBar.dataset.initialized = 'true';
    var panel = stickyBar.closest('.product__info-container');
    if (!panel) return;
    var mainContainer = panel.closest('#pdp-main-container') || panel;
    var mainButton = panel.querySelector('product-form .product-form__submit');
    if (!mainButton) return;

    var qtyInput = stickyBar.querySelector('.desktop-sticky-atc__qty-input');
    var plusBtn = stickyBar.querySelector('.desktop-sticky-atc__qty-btn--plus');
    var minusBtn = stickyBar.querySelector('.desktop-sticky-atc__qty-btn--minus');
    var priceEl = stickyBar.querySelector('[data-desktop-sticky-price]');
    var atcBtn = stickyBar.querySelector('.desktop-sticky-atc__atc-btn');

    // --- Quantity buttons ---
    plusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      val++;
      qtyInput.value = val;
      syncToPdpQuantity(val);
    });

    minusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) {
        val--;
        qtyInput.value = val;
        syncToPdpQuantity(val);
      }
    });

    // --- ATC Button: trigger click on the main product form submit ---
    atcBtn.addEventListener('click', function () {
      var mainAtcBtn = panel.querySelector('product-form .product-form__submit');
      if (mainAtcBtn && !mainAtcBtn.disabled) {
        mainAtcBtn.click();
      }
    });

    // --- Wishlist Button: proxy to the main PDP Swym wishlist button ---
    // Swym injects its real heart into .swym-wishlist-button-bar on the main
    // PDP. This sticky button forwards clicks there (single source of truth)
    // and mirrors the "added" state so the sticky heart stays in sync.
    var wishlistBtn = stickyBar.querySelector('.desktop-sticky-atc__wishlist-btn');

    function getSwymBtn() {
      return document.querySelector(
        '.swym-pdp-btn .swym-wishlist-button-bar button.swym-button, ' +
        '.swym-wishlist-button-bar button.swym-button'
      );
    }

    function isSwymAdded(btn) {
      if (!btn) return false;
      // Swym marks the added state with these signals depending on config;
      // check all so the mirror is robust across versions. The most reliable
      // is aria-label switching to "Remove from Wishlist" when added.
      var ariaLabel = (btn.getAttribute('aria-label') || '').toLowerCase();
      return (
        btn.classList.contains('swym-added') ||
        btn.classList.contains('on-wishlist') ||
        btn.getAttribute('aria-pressed') === 'true' ||
        ariaLabel.indexOf('remove') !== -1
      );
    }

    function syncWishlistState() {
      if (!wishlistBtn) return;
      var added = isSwymAdded(getSwymBtn());
      wishlistBtn.classList.toggle('is-added', added);
      wishlistBtn.setAttribute('aria-pressed', added ? 'true' : 'false');
    }

    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function () {
        var swymBtn = getSwymBtn();
        if (swymBtn) {
          swymBtn.click();
          // Swym updates its own state asynchronously; re-read shortly after.
          setTimeout(syncWishlistState, 300);
        }
      });

      // Keep the sticky heart in sync with the main button. Swym toggles
      // classes / aria-label on its button when the item is added/removed; a
      // MutationObserver catches those changes without polling.
      var attrObserver = null;
      function attachAttrObserver() {
        if (attrObserver || !('MutationObserver' in window)) return;
        var swymBtn = getSwymBtn();
        if (!swymBtn) return;
        attrObserver = new MutationObserver(syncWishlistState);
        attrObserver.observe(swymBtn, {
          attributes: true,
          attributeFilter: ['class', 'aria-pressed', 'aria-label']
        });
        syncWishlistState();
      }

      attachAttrObserver();

      // Swym injects its button into .swym-wishlist-button-bar asynchronously.
      // Watch the container so we attach the attribute observer (and sync) as
      // soon as the real button appears, even if this script ran first.
      if (!attrObserver && 'MutationObserver' in window) {
        var container = document.querySelector('.swym-pdp-btn .swym-wishlist-button-bar')
          || document.querySelector('.swym-wishlist-button-bar');
        if (container) {
          var containerObserver = new MutationObserver(function () {
            attachAttrObserver();
            if (attrObserver) containerObserver.disconnect();
          });
          containerObserver.observe(container, { childList: true, subtree: true });
        }
      }

      // Initial sync + a couple of delayed re-checks (Swym may hydrate late).
      syncWishlistState();
      setTimeout(syncWishlistState, 1000);
      setTimeout(function () {
        attachAttrObserver();
        syncWishlistState();
      }, 2500);
    }

    // --- Sync quantity from PDP quantity input to desktop sticky ---
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.quantity__input, quantity-input input[form^="product-form"]')) return;
      qtyInput.value = e.target.value;
    });

    // --- Sync from mobile sticky bar ---
    document.addEventListener('click', function (e) {
      var mobileQtyInput = document.querySelector('.new-sticky-atc-bar__quantity-input');
      if (mobileQtyInput && e.target.closest('.new-sticky-atc-bar__quantity-btn')) {
        setTimeout(function () {
          qtyInput.value = mobileQtyInput.value;
        }, 50);
      }
    });

    function syncToPdpQuantity(val) {
      var pdpQtyInput = document.querySelector('.quantity-selector-custom quantity-input .quantity__input');
      if (pdpQtyInput) {
        pdpQtyInput.value = val;
        pdpQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Also sync to mobile sticky
      var mobileQtyInput = document.querySelector('.new-sticky-atc-bar__quantity-input');
      if (mobileQtyInput) {
        mobileQtyInput.value = val;
      }
    }

    // --- IntersectionObserver: watch the main product form ---
    var productForm = mainButton;
    if (!productForm) return;

    // Evaluate visibility from the observed element's geometry. This runs on
    // every scroll/resize (not just IntersectionObserver threshold crossings)
    // so the bar reliably toggles even when the main ATC leaves the viewport
    // in a single fast scroll or a slow scroll that never re-crosses a fixed
    // threshold.
    // Move live app elements rather than cloning their IDs or event handlers.
    var extras = [];
    var restoreExtrasTimer = null;
    function syncExtras(show) {
      if (show) {
        [
          ['[id*="smile_io_smile_points_on_product_page"]', '[data-desktop-sticky-points]'],
          ['.pdp-block--add_to_registry', '[data-desktop-sticky-registry]']
        ].forEach(function (pair) {
          var node = panel.querySelector(pair[0]);
          var slot = stickyBar.querySelector(pair[1]);
          if (!node || slot.contains(node)) return;
          var placeholder = document.createElement('div');
          var nodeStyle = window.getComputedStyle(node);
          placeholder.style.height = node.getBoundingClientRect().height + 'px';
          placeholder.style.marginTop = nodeStyle.marginTop;
          placeholder.style.marginBottom = nodeStyle.marginBottom;
          node.before(placeholder);
          extras.push({ node: node, placeholder: placeholder });
          slot.appendChild(node);
        });
      } else {
        extras.forEach(function (item) {
          item.placeholder.replaceWith(item.node);
        });
        extras = [];
      }
    }

    function updateVisibility() {
      var panelRect = panel.getBoundingClientRect();
      var parentRect = (stickyBar.offsetParent || panel).getBoundingClientRect();
      stickyBar.style.setProperty('--desktop-atc-left', (panelRect.left - parentRect.left) + 'px');
      stickyBar.style.setProperty('--desktop-atc-width', panelRect.width + 'px');
      var rect = productForm.getBoundingClientRect();
      // Desktop PDPs hide the full header and use the 74px condensed nav.
      // Measure rendered bounds so hidden/transformed-away headers contribute
      // nothing and responsive header heights do not need a hardcoded offset.
      var viewportTop = 0;
      document.querySelectorAll('.header-v2-condensed, .header-v2-wrapper').forEach(function (header) {
        var headerRect = header.getBoundingClientRect();
        var headerStyle = window.getComputedStyle(header);
        if (headerRect.width > 0 && headerRect.height > 0 &&
            headerRect.top <= 1 && headerRect.bottom > 0 &&
            headerStyle.visibility !== 'hidden' && headerStyle.display !== 'none' &&
            parseFloat(headerStyle.opacity) !== 0) {
          viewportTop = Math.max(viewportTop, headerRect.bottom);
        }
      });
      var show = window.innerWidth >= DESKTOP_BREAKPOINT &&
        rect.width > 0 && rect.height > 0 && rect.bottom <= viewportTop &&
        mainContainer.getBoundingClientRect().bottom > viewportTop;
      if (show) {
        clearTimeout(restoreExtrasTimer);
        restoreExtrasTimer = null;
        syncExtras(true);
      } else if (extras.length && !restoreExtrasTimer) {
        // Keep a stable height throughout the fade-out before returning apps.
        restoreExtrasTimer = setTimeout(function () {
          syncExtras(false);
          restoreExtrasTimer = null;
        }, 200);
      }
      // Moving app content can change panel height. Measure again before reveal.
      panelRect = panel.getBoundingClientRect();
      parentRect = (stickyBar.offsetParent || panel).getBoundingClientRect();
      // Keep the bar inside the PDP: follow the viewport until the main
      // container's bottom pushes it upward, alongside the sticky gallery.
      var containerRect = mainContainer.getBoundingClientRect();
      var barHeight = stickyBar.offsetHeight;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var bottom = Math.min(viewportHeight, containerRect.bottom, panelRect.bottom);
      var top = Math.max(panelRect.top, bottom - barHeight);
      stickyBar.style.setProperty('--desktop-atc-top', (top - parentRect.top) + 'px');
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBar.toggleAttribute('inert', !show);
    }

    // IntersectionObserver acts as a lightweight trigger; the actual decision
    // is always made by updateVisibility() reading live geometry.
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(
      onScrollOrResize,
      { root: null, threshold: [0, 1], rootMargin: '0px' }
    ) : null;

    if (observer) observer.observe(productForm);
    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(onScrollOrResize);
      resizeObserver.observe(panel);
      resizeObserver.observe(productForm);
      resizeObserver.observe(stickyBar);
      resizeObserver.observe(mainContainer);
      document.querySelectorAll('.header-v2-condensed, .header-v2-wrapper').forEach(function (header) {
        resizeObserver.observe(header);
      });
    }

    // Passive scroll + resize listeners guarantee the state stays correct
    // between threshold crossings.
    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    document.querySelectorAll('.header-v2-condensed, .header-v2-wrapper').forEach(function (header) {
      header.addEventListener('transitionend', onScrollOrResize);
    });

    // Set the correct initial state.
    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();